import { loadCSS } from 'public/lib/loadCSS.js'

loadCSS('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;0,900;1,400;1,500;1,700&display=swap')
